"use client"

import Link from "next/link"
import { Button } from "@/components/ui/button"
import { ArrowLeft, Home } from "lucide-react"
export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md mx-auto text-center">
        <div className="mb-8">
          <h1 className="text-9xl   text-muted">404</h1>
          <div className="text-2xl    text-foreground mb-4">
            Хуудас олдсонгүй
          </div>
          <p className="text-muted-foreground mb-8">
            Уучлаарай, таны хайж буй хуудас олдсонгүй.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link href="/">
            <Button className="bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
              <Home className="w-4 h-4 mr-2" />
              Нүүр хуудас
            </Button>
          </Link>
          
          <Button 
            variant="outline" 
            onClick={() => window.history.back()}
            className="px-6 py-3 rounded-xl hover:bg-muted transition-all duration-300"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Буцах
          </Button>
        </div>
      </div>
    </div>
  )
}